import axios from "../lib/axios";

export const createNews = async (data) => {
  try {
    const response = await axios.post("/news", data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to create news");
  }
};

export const getAllNews = async ({
  status = "",
  lastId = "",
  limit = 10,
  visibility = "",
  homepage = false,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (status) params.append("status", status);
    if (lastId) params.append("lastId", lastId);
    params.append("limit", limit.toString());
    if (visibility) params.append("visibility", visibility);
    if (homepage) params.append("homepage", homepage.toString());

    const response = await axios.get(`/news/all?${params.toString()}`);

    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to fetch news");
  }
};

export const getNewsById = async (id) => {
  try {
    const response = await axios.get(`/news/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch news article"
    );
  }
};

export const getNewsByMemberId = async (id) => {
  try {
    const response = await axios.get(`/news/member-news/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch news article"
    );
  }
};

export const updateNews = async (id, data) => {
  try {
    const response = await axios.put(`/news/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to update news");
  }
};

export const manageNews = async ({ id, action, status }) => {
  try {
    const payload = { action };
    if (action === "update" && status) {
      payload.status = status;
    }

    const response = await axios.patch(`/news/${id}/manage`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to manage news");
  }
};
